module.exports = __webpack_public_path__ + "img/aspire_logo-1.8c42e24d.svg";